/**
 * Get the country code from browser locale
 * @param win The window to read the locale from. Defaults to the global
 * window, or null when server-side rendering. Injectable because jsdom 26
 * does not allow tests to replace the global window.
 */
export function getBrowserLocale(
  win = typeof window !== 'undefined' ? window : null,
): string {
  let locale

  if (win && win.navigator) {
    locale =
      // eslint-disable-next-line zeffo/no-navigator-language
      win.navigator.language || win.navigator.languages?.[0]
  }

  return locale
}
